module.exports = __webpack_public_path__ + "static/media/MooreBenefitResources_Inc.b7fd091f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/MooreBenefitResources_Inc.jpg
// module id = 44
// module chunks = 0